module.exports = {"130709001":"西湾子街道","130709100":"西湾子镇","130709101":"高家营镇","130709200":"四台嘴乡","130709201":"红旗营乡","130709202":"石窑子乡","130709203":"驿马图乡","130709204":"石嘴子乡","130709205":"狮子沟乡","130709206":"清三营乡","130709207":"白旗乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130709.json
// module id = 270
// module chunks = 0